import { field } from "@platform/ui/styles";
import * as React from "react";
import { twMerge } from "tailwind-merge";

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentPropsWithoutRef<"textarea">>(
  ({ className, ...rest }, ref) => {
    return (
      <textarea
        className={twMerge(
          field(),
          // Focus Styles
          "focus-visible:bg-(--field-bg-focus)",
          "focus-visible:border-(--field-border-focus)",
          "focus-visible:ring-2 focus-visible:ring-(--field-ring) focus-visible:outline-none",
          "focus-visible:inset-shadow-none",

          // Invalid styles
          "aria-invalid:border-(--field-border-error)",
          "aria-invalid:ring-2 aria-invalid:ring-(--field-ring-error)",

          // Disabled styles
          "disabled:cursor-not-allowed disabled:text-(--field-text-disabled) disabled:opacity-50 disabled:inset-shadow-none",

          // Readonly styles
          "read-only:text-ds-text-tertiary read-only:border-(--field-border-disabled) read-only:bg-(--field-bg-focus) read-only:opacity-100 read-only:inset-shadow-none",

          // Placeholder styles
          "placeholder:text-(--field-text-placeholder)",

          // Base Styles
          "flex min-h-[60px] w-full rounded-md border border-(--field-border) bg-(--field-bg) px-3 py-2 text-sm inset-shadow-sm transition-all",
        )}
        ref={ref}
        {...rest}
      />
    );
  },
);
Textarea.displayName = "Textarea";
